/*
 * One date style for the whole app: dd-mm-yyyy (for example 08-03-2026),
 * with an optional 12-hour time (08-03-2026, 10:56:23 AM).
 */
const pad = (number) => String(number).padStart(2, "0");

const toDate = (value) => {
  if (value === null || value === undefined || value === "") return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;

  // "2026-03-08 10:56:23" (MySQL style) is read as local time.
  const text = String(value).replace(/^(\d{4}-\d{2}-\d{2}) (\d)/, "$1T$2");
  const date = new Date(text);

  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDate = (value, fallback = "-") => {
  const date = toDate(value);
  if (!date) return fallback;

  return `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()}`;
};

export const formatTime = (value, fallback = "-") => {
  const date = toDate(value);
  if (!date) return fallback;

  const hours = date.getHours();
  const suffix = hours >= 12 ? "PM" : "AM";
  const hour12 = hours % 12 || 12;

  return `${pad(hour12)}:${pad(date.getMinutes())}:${pad(date.getSeconds())} ${suffix}`;
};

export const formatDateTime = (value, fallback = "-") => {
  const date = toDate(value);
  if (!date) return fallback;

  return `${formatDate(date)}, ${formatTime(date)}`;
};
